import { render, staticRenderFns } from "./zCountDown.vue?vue&type=template&id=622b4655&scoped=true&"
import script from "./zCountDown.vue?vue&type=script&setup=true&lang=js&"
export * from "./zCountDown.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./zCountDown.vue?vue&type=style&index=0&id=622b4655&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622b4655",
  null
  
)

export default component.exports